module.exports = __webpack_public_path__ + "d335bdd926ca7472b0e1e5dd655513e6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/painted-nails-black.png
// module id = 1900
// module chunks = 0